import ReactHTMLTableToExcel from "react-html-table-to-excel";

const DAY_NAMES     = ["Lunes","Martes","Miércoles","Jueves","Viernes","Sábado","Domingo"];
const SHOWCASES     = ["No cuenta","Aéreo","2 niveles","5 niveles","6x8 niveles","Bolsa"];
const CUSTOMER_TYPE = ["Pepsico","Propio"];

// Volume badge colors
const VOLUME_STYLES = {
    "3A": "bg-emerald-100 dark:bg-emerald-900/40 text-emerald-700 dark:text-emerald-300",
    "2A": "bg-blue-100 dark:bg-blue-900/40 text-blue-700 dark:text-blue-300",
    "A":  "bg-cyan-100 dark:bg-cyan-900/40 text-cyan-700 dark:text-cyan-300",
    "B":  "bg-amber-100 dark:bg-amber-900/40 text-amber-700 dark:text-amber-300",
    "C":  "bg-orange-100 dark:bg-orange-900/40 text-orange-700 dark:text-orange-300",
    "D":  "bg-red-100 dark:bg-red-900/40 text-red-700 dark:text-red-300",
    "E":  "bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-400",
};
const VOLUME_KEYS = ["3A","2A","A","B","C","D","E"];

const thBase  = "px-3 py-2 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap border-b border-gray-200 dark:border-gray-600";
const tdBase  = "px-3 py-2 text-xs whitespace-nowrap border-b border-gray-100 dark:border-gray-700 align-middle";
const money   = (v) => `S/ ${Number(v).toFixed(2)}`;

export function ClientPortfolioList({ orders }) {
    if (!orders || orders.length === 0) {
        return (
            <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm">
                <div className="py-16 text-center">
                    <div className="inline-flex items-center justify-center h-14 w-14 rounded-full bg-gray-100 dark:bg-gray-700 mb-4">
                        <i className="fas fa-users text-gray-400 dark:text-gray-500 text-2xl"></i>
                    </div>
                    <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Sin resultados</p>
                    <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
                        Configure los filtros y presione Buscar para ver la cartera de clientes.
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm overflow-hidden">

            {/* Card header */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                <div>
                    <h2 className="text-base font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                        <i className="fas fa-users text-blue-500"></i>
                        Cartera de clientes
                    </h2>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{orders.length} clientes</p>
                </div>
                {/* Legend */}
                <div className="flex flex-wrap items-center gap-2 text-xs">
                    {VOLUME_KEYS.map((k) => (
                        <span key={k} className={`inline-block rounded-full px-2 py-0.5 font-medium ${VOLUME_STYLES[k]}`}>{k}</span>
                    ))}
                    <ReactHTMLTableToExcel
                        id="test-table-xls-button"
                        className="inline-flex items-center gap-1.5 rounded-lg bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-medium px-3 py-1.5 transition-colors"
                        table="table-to-xls"
                        filename="report_of_portfolios"
                        sheet="report"
                        buttonText="↓ Exportar XLS"
                    />
                </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto max-h-[70vh] overflow-y-auto bg-white dark:bg-gray-900">
                <table className="min-w-full text-sm border-separate border-spacing-0" id="table-to-xls">
                    <thead className="sticky top-0 z-10">
                        {/* Group row */}
                        <tr>
                            <th colSpan={8}  className={`${thBase} bg-amber-500 dark:bg-amber-700 text-white`}>
                                <i className="fas fa-user mr-1"></i>Información del cliente
                            </th>
                            <th colSpan={4}  className={`${thBase} bg-cyan-600 dark:bg-cyan-800 text-white border-l-2 border-cyan-400`}>
                                <i className="fas fa-shopping-cart mr-1"></i>Compras mensuales
                            </th>
                            <th colSpan={8}  className={`${thBase} bg-blue-600 dark:bg-blue-800 text-white border-l-2 border-blue-400`}>
                                <i className="fas fa-layer-group mr-1"></i>Clasificación PDV
                            </th>
                            <th colSpan={3}  className={`${thBase} bg-violet-600 dark:bg-violet-800 text-white border-l-2 border-violet-400`}>
                                <i className="fas fa-balance-scale mr-1"></i>Mes comparativo
                            </th>
                        </tr>
                        {/* Column row */}
                        <tr>
                            {/* Cliente info */}
                            {["Vendedor 3PD","Cód. Ruta","Día visita","Cód. PDV","Nombre PDV","Dirección PDV","Tipo Cliente","Exhibidor"].map((h) => (
                                <th key={h} className={`${thBase} bg-amber-50 dark:bg-amber-900/30 text-amber-800 dark:text-amber-200`}>{h}</th>
                            ))}
                            {/* Compras mensuales */}
                            <th className={`${thBase} bg-cyan-50 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-200 border-l-2 border-cyan-200 dark:border-cyan-700`}>Mes 1 (S/)</th>
                            <th className={`${thBase} bg-cyan-50 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-200`}>Mes 2 (S/)</th>
                            <th className={`${thBase} bg-cyan-50 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-200`}>Mes 3 (S/)</th>
                            <th className={`${thBase} bg-cyan-50 dark:bg-cyan-900/30 text-cyan-800 dark:text-cyan-200`}>Prom. Semanal (S/)</th>
                            {/* Clasificación */}
                            <th className={`${thBase} bg-blue-50 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 border-l-2 border-blue-200 dark:border-blue-700`}>Clasif.</th>
                            {VOLUME_KEYS.map((k) => (
                                <th key={k} className={`${thBase} bg-blue-50 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200`}>{k}</th>
                            ))}
                            {/* Mes comparativo */}
                            <th className={`${thBase} bg-violet-50 dark:bg-violet-900/30 text-violet-800 dark:text-violet-200 border-l-2 border-violet-200 dark:border-violet-700`}>Mes 4 (S/)</th>
                            <th className={`${thBase} bg-violet-50 dark:bg-violet-900/30 text-violet-800 dark:text-violet-200`}>Prom. Sem. Mes 4 (S/)</th>
                            <th className={`${thBase} bg-violet-50 dark:bg-violet-900/30 text-violet-800 dark:text-violet-200`}>Diferencia (S/)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((o, index) => {
                            const diff = Number(o.differenceBetweenAverages);
                            return (
                                <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-800/40 transition-colors">
                                    {/* Cliente info — amber tint */}
                                    <td className={`${tdBase} font-medium text-gray-800 dark:text-gray-200 bg-amber-50/50 dark:bg-amber-900/10`}>
                                        {o.sellerFirstName} {o.sellerLastName}
                                    </td>
                                    <td className={`${tdBase} text-center text-gray-600 dark:text-gray-400 bg-amber-50/50 dark:bg-amber-900/10`}>{o.sellerGangName}</td>
                                    <td className={`${tdBase} text-center text-gray-600 dark:text-gray-400 bg-amber-50/50 dark:bg-amber-900/10`}>{DAY_NAMES[o.clientVisitDay]}</td>
                                    <td className={`${tdBase} text-center font-bold text-gray-700 dark:text-gray-300 bg-amber-50/50 dark:bg-amber-900/10`}>{o.clientObservation}</td>
                                    <td className={`${tdBase} font-medium text-gray-800 dark:text-gray-200 bg-amber-50/50 dark:bg-amber-900/10`}>
                                        {o.clientName} {o.clientFirstSurname} {o.clientSecondSurname}
                                    </td>
                                    <td className={`${tdBase} text-gray-600 dark:text-gray-400 bg-amber-50/50 dark:bg-amber-900/10`}>{o.clientAddress}</td>
                                    <td className={`${tdBase} text-center text-gray-600 dark:text-gray-400 bg-amber-50/50 dark:bg-amber-900/10`}>{CUSTOMER_TYPE[o.clientCustomerType]}</td>
                                    <td className={`${tdBase} text-center text-gray-600 dark:text-gray-400 bg-amber-50/50 dark:bg-amber-900/10`}>{SHOWCASES[o.clientShowCases]}</td>

                                    {/* Compras mensuales — cyan tint */}
                                    <td className={`${tdBase} text-right font-semibold text-cyan-700 dark:text-cyan-400 bg-cyan-50/50 dark:bg-cyan-900/10 border-l-2 border-cyan-100 dark:border-cyan-800`}>{money(o.month1)}</td>
                                    <td className={`${tdBase} text-right font-semibold text-cyan-700 dark:text-cyan-400 bg-cyan-50/50 dark:bg-cyan-900/10`}>{money(o.month2)}</td>
                                    <td className={`${tdBase} text-right font-semibold text-cyan-700 dark:text-cyan-400 bg-cyan-50/50 dark:bg-cyan-900/10`}>{money(o.month3)}</td>
                                    <td className={`${tdBase} text-right font-semibold text-gray-700 dark:text-gray-300`}>{money(o.average)}</td>

                                    {/* Clasificación — blue tint */}
                                    <td className={`${tdBase} text-center border-l-2 border-blue-100 dark:border-blue-800`}>
                                        <span className={`inline-block rounded-full px-2 py-0.5 text-xs font-bold ${VOLUME_STYLES[o.purchaseVolume] ?? "bg-gray-100 text-gray-600"}`}>
                                            {o.purchaseVolume}
                                        </span>
                                    </td>
                                    {VOLUME_KEYS.map((k) => (
                                        <td key={k} className={`${tdBase} text-center text-xs text-gray-500 dark:text-gray-400`}>
                                            {o.purchaseVolume === k ? <span className="inline-block h-2 w-2 rounded-full bg-blue-500"></span> : ""}
                                        </td>
                                    ))}

                                    {/* Mes comparativo — violet tint */}
                                    <td className={`${tdBase} text-right font-semibold text-violet-700 dark:text-violet-400 bg-violet-50/50 dark:bg-violet-900/10 border-l-2 border-violet-100 dark:border-violet-800`}>{money(o.month4)}</td>
                                    <td className={`${tdBase} text-right font-semibold text-violet-700 dark:text-violet-400 bg-violet-50/50 dark:bg-violet-900/10`}>{money(o.average2)}</td>
                                    <td className={`${tdBase} text-right font-bold ${diff >= 0 ? "text-emerald-600 dark:text-emerald-400" : "text-red-600 dark:text-red-400"} bg-violet-50/50 dark:bg-violet-900/10`}>
                                        {diff >= 0 ? "+" : ""}{money(o.differenceBetweenAverages)}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
